import { ChangeEvent, FC } from "react";

import { InputText } from '@repo/wb-ui-kit';

import st from "./CommentBlock.module.scss";

type Props = {
  title: string,
  comment: string,
  setComment: (event: ChangeEvent<HTMLInputElement>) => void,
};

export const CommentBlock: FC<Props> = ({
  title,
  comment,
  setComment,
}) => {
  return (
    <div className={st.comment_block}>
      <h4>{title || "Развернутый ответ"}</h4>
      <InputText
        className={st.input_text}
        placeholder='Введите коментарий...'
        value={comment}
        onChange={setComment}
      >
      </InputText>
    </div>
  );
};